import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemerals = (setEphemerals: Function, setLoaded: Function, language: string) => {
  setLoaded(false);
  ApiService.get("ephemeral-evaluations")
    .then((resp) => setEphemerals(resp.data.ephemeral_evaluations))
    .catch((err) => {
      console.error("Error fetching ephemeral evaluations:", err);
      alert(translate(language, "PAGES.EPHEMERAL.ERROR.FETCH"));
    })
    .finally(() => setLoaded(true));
};
